import api from './api';

export const planosAPI = {
  list: () => api.get('/planos'),
  listAdmin: () => api.get('/planos/admin/todos'),
  get: (id) => api.get(`/planos/${id}`),
  create: (data) => api.post('/planos', data),
  update: (id, data) => api.patch(`/planos/${id}`, data),
  delete: (id) => api.delete(`/planos/${id}`),
  getUso: (clienteId) => api.get(`/planos/uso/${clienteId}`),
  alterarPlano: (clienteId, planoId) => api.post(`/planos/alterar/${clienteId}`, { plano_id: planoId }),
};

export default planosAPI;
